import { Injectable } from "@angular/core";
import { AuthService } from "../auth/auth.service";

@Injectable({ providedIn: 'root' })
export class RoleService {
    constructor(private _authService: AuthService) { }

    public isInRole(roles: string[]): boolean {
        if (roles != undefined && roles.length > 0) {
            const userRoles = this._authService.roles;

            return roles.some(role => userRoles.indexOf(role) > -1);
        } else {
            return false;
        }
    }
}